import Loading from "theme/components/Loading";
import React from "react";
import loadable from "@loadable/component";
import styled from "theme/libs/styled";

const LoadingWrapper = styled("div")`
    position: relative;

    ${({ theme }) => theme.above.desktopSm} {
        grid-row-start: 2;
        grid-column-start: 2;
        grid-column-end: 5;
    }
`;

const options = {
    fallback: (
        <LoadingWrapper>
            <Loading />
        </LoadingWrapper>
    ),
};

const postTemplates = {
    default: loadable(() => import("./Default"), options),
    customer_service_overview: loadable(() => import("./Overview"), options),
    customer_service_contact: loadable(() => import("./Contact"), options),
    customer_service_faq: loadable(() => import("./Faq"), options),
};

export default postTemplates;
